import { render, staticRenderFns } from "./ValidationElement.vue?vue&type=template&id=7b923206&scoped=true"
import script from "./ValidationElement.vue?vue&type=script&lang=js"
export * from "./ValidationElement.vue?vue&type=script&lang=js"
import style0 from "./ValidationElement.vue?vue&type=style&index=0&id=7b923206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b923206",
  null
  
)

export default component.exports